import React from "react";
import { handleScanResult } from "../../helpers/handleScanResultUtils";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import HoneywellScannerPagePresentation from "../honeywell-scanner-page/HoneywellScannerPagePresentation";
import { SymbologyType } from "../../types/SymbologyType";
import { ScanResultType } from "../../types/ScanResultType";
import { useDefaultScannerBehavior } from "../../hooks/useDefaultScannerBehavior";
import useCoworkerHubScanner from "../../hooks/useCoworkerHubScanner";
import {
  useScannerInput,
  processScanResult,
} from "../../hooks/useScannerInput";
import { useDebouncedValue } from "@coworker/app/src/hooks/useDebounce";

const CoworkerHubScannerPage: React.FC = () => {
  const navigate = useFixaNavigate();
  const { navigateToSearch, error, setError, taskType, readyToScanText } =
    useDefaultScannerBehavior();
  useCoworkerHubScanner((data, type) => {
    const scanResult: ScanResultType = {
      scannedBarcode: data,
      symbologyFormat: type as SymbologyType,
    };
    handleScanResult(scanResult, taskType, navigate);
  });

  React.useEffect(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }, []);
  React.useEffect(() => {
    const inputElement = document.getElementById("scanner-text-input");
    if (inputElement) {
      inputElement.focus();
    }
  }, []);

  const [debouncedInput, setDebouncedInput] = React.useState("");
  const debouncedValue = useDebouncedValue(debouncedInput, 200);

  const handleInputChange = useScannerInput((value, symbologyFormat) => {
    processScanResult(value, symbologyFormat, taskType, navigate);
  });

  React.useEffect(() => {
    if (debouncedValue) {
      handleInputChange({
        target: { value: debouncedValue },
      } as React.ChangeEvent<HTMLInputElement>);
    }
  }, [debouncedValue, handleInputChange]);

  return (
    <>
      <input
        type="text"
        id="scanner-text-input"
        aria-hidden="true"
        onChange={(e) => setDebouncedInput(e.target.value)}
        style={{ height: "12px", outline: "none" }}
      />
      <HoneywellScannerPagePresentation
        error={error}
        setError={setError}
        readyToScanText={readyToScanText}
        scannerType="hdi"
        taskType={taskType}
        pushSearch={navigateToSearch}
      />
    </>
  );
};

export default CoworkerHubScannerPage;
